module.exports = __webpack_public_path__ + "LatoLatin-Bold.20ee9bd18996dbf668b6.ttf";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Bold.ttf
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Bold.ttf
// module chunks = styles